/**
 * @module app.CacheBustService
 */
import appBase from './index.js';

export default class CacheBustService {
  /**
   * @param {string} cacheBustingVersion
   * @ngInject
   */
  constructor(cacheBustingVersion) {
    /**
     * @private
     */
    this.cacheBustingVersion_ = cacheBustingVersion;
  }

  /**
   * @return {string}
   */
  getVersion() {
    return this.cacheBustingVersion_;
  }

  /**
   * @param {string} url
   * @return {string}
   */
  addSuffix(url) {
    return `${url}?v=${this.cacheBustingVersion_}`;
  }
}

appBase.service('appCacheBustService', CacheBustService);
